/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardBookingDialogController', BoardBookingDialogController);

    BoardBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ProjectDetailBooking'];

    function BoardBookingDialogController ($timeout, $scope, $uibModalInstance, entity, ProjectDetailBooking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.booking.oldStatus = vm.booking.status;
        vm.booking.individualPrice = vm.booking.dept.priceCategory === "individual";
        vm.booking.oldIndividualPrice = vm.booking.individualPrice;
        vm.booking.nonIndividual = !vm.booking.individualPrice;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.booking.individualPrice = !vm.booking.nonIndividual;
            ProjectDetailBooking.update(vm.booking, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:bookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
